import { redirect } from "@tanstack/react-router";

/**
 * TanStack Router beforeLoad guard — requires a signed-in Clerk session.
 * Redirects unauthenticated users to /login.
 *
 * Usage: `beforeLoad: requireAuth`
 */
export function requireAuth() {
  const clerk = window.Clerk;
  if (!clerk?.loaded) return;
  if (!clerk.user) {
    throw redirect({ to: "/login" });
  }
}

/**
 * TanStack Router beforeLoad guard — requires signed-in + org:admin role.
 * Non-admins are redirected to /dashboard.
 *
 * Usage: `beforeLoad: requireAdmin`
 */
export function requireAdmin() {
  const clerk = window.Clerk;
  if (!clerk?.loaded) return;
  if (!clerk.user) {
    throw redirect({ to: "/login" });
  }

  const role = clerk.organization?.membership?.role;
  const isAdmin = role === "org:admin" || role === "admin";
  if (!isAdmin) {
    throw redirect({ to: "/dashboard" });
  }
}
